<template lang="pug">
v-row(
  align="center"
  wrap
)
  v-col(
    :cols="12"
    :md="4"
  )
    region-input(
      v-model="regionId"
      hide-details
      toplabel
    )

  v-col(
    :cols="12"
    :md="4"
  )
    directory-mun-input(
      v-model="munId"
      label="Муниципалитет"
      :region="regionId"
      :return-object="false"
      :disabled="!regionId"
      toplabel
      hide-details
    )

  v-col(
    :cols="12"
    :md="4"
  )
    template(v-if="ORGANIZER_DATA.component_condition")
      component(
        :is="ORGANIZER_DATA.component"
        v-bind="ORGANIZER_DATA.component_attrs"
        v-on="ORGANIZER_DATA.component_listeners"
      )
</template>

<script>
import RegionInput from '@/components/inputs/RegionInput.vue';
import SelectOrganizers from '@/components/inputs/SelectOrganizers.vue';
import DirectoryMunInput from '@/components/inputs/DirectoryMunInput.vue';
import SelectEventOrganizers from '@/components/inputs/SelectEventOrganizers.vue';

export default {
  components: {
    RegionInput,
    SelectOrganizers,
    DirectoryMunInput,
  },
  props: {
    // Event
    value: {
      type: Object,
      required: true,
    },
    organizations: {
      type: Array,
      default: () => [],
    },
    register: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regionId: this.$user.profile.region?.id || null,
      munId: this.$user.profile.municipality?.id || null,
    };
  },
  computed: {
    ORGANIZER_DATA() {
      const { organizations, register, regionId, munId, value } = this;

      if (register) {
        return {
          component: SelectEventOrganizers,
          component_attrs: {
            'region-id': regionId,
            'mun-id': munId,
            value,
          },
          component_listeners: {
            input: ($event) => {
              this.$emit('input', $event);
            },
          },
          component_condition: value.highest_event && regionId && munId,
        };
      }

      return {
        component: SelectOrganizers,
        component_attrs: {
          value: organizations,
          'region-id': regionId,
          'mun-id': munId,
        },
        component_listeners: {
          input: ($event) => this.$emit('update:organizations', $event),
          unset: ($event) => this.$emit('unset', $event),
        },
        component_condition: () => true,
      };
    },
  },
  watch: {
    regionId(val) {
      this.munId = null;
      this.$emit('update:region-id', val);
      this.$emit('input', null);
    },
    munId(val) {
      this.$emit('update:mun-id', val);
      this.$emit('input', null);
    },
    value: {
      handler(value) {
        if (value && !this.register) {
          const [organization] = this.organizations;
          this.regionId = organization?.region_id || this.value.area?.region_id;
          this.munId = organization?.municipality_id || this.value.area?.municipality_id;
        }
      },
      immediate: true,
    },
  },
};
</script>
